<template>
  <section class="start-teaching-advantages">
    <BaseTitleSection :title="title" />
    <AdvantagesList :list="list" />
  </section>
</template>

<script>
import BaseTitleSection from '@design-system/base/title/title-section'
import staticData from './static-data'
import AdvantagesList from '~/components/pages/start-teaching/advantages/advantages-list'
export default {
  name: 'StartTeacherAdvantages',
  components: {
    AdvantagesList,
    BaseTitleSection
  },
  data () {
    return {
      ...staticData
    }
  }
}
</script>

<style scoped lang="scss">
.start-teaching-advantages {
  @apply container;
  .base-section-title {
    @apply mb-12;
  }
}
</style>
